
<lib-filters-component [filters_options]="photos_service.filterOptions"></lib-filters-component>
<div style="margin-bottom: 25px;" *ngIf="data|async as photos">
  <div class="photos">
  <ng-container> <ng-container *ngFor="let photo of photos">
    <div class="photo_wrapper"style="position: relative;">
   <img [alt]="photo.alt" (dblclick)="selectPhoto(photo.urls[0].median, photo?.competitions[0]?.id)" (click)="selectPhoto(photo.urls[0].median, photo?.competitions[0]?.id)" [lazyLoad]="photo.urls[0].median" />
   <div (dblclick)="selectPhoto(photo.urls[0].median, photo?.competitions[0]?.id)" (click)="selectPhoto(photo.urls[0].median, photo?.competitions[0]?.id)" *ngIf="photo.competitions && photo.competitions.length > 0" class="text-block">
    <h6><a title="{{photo.competitions[0].name}}" class="uppertext-no-viewport" >
      {{limitNameOfEvent(photo.competitions[0].name)}}</a></h6>
      <div class="country">
      <div class="country__name">
        {{photo.competitions[0].place }}
      </div>
      <lib-country-flag [id]="photo.competitions[0].country"></lib-country-flag>
      <p>
        {{photo.competitions[0].date_start | date :'d' }}
        <ng-container *ngIf="photo.competitions[0].date_start && photo.competitions[0].date_start !== '' && photo.competitions[0].date_end && photo.competitions[0].date_end !== '' &&  photo.competitions[0].date_end !==  photo.competitions[0].date_start">{{'TO' | transloco}}</ng-container>
        <ng-container *ngIf="photo.competitions[0].date_end && photo.competitions[0].date_end != '' && photo.competitions[0].date_end !== photo.competitions[0].date_start"> {{photo.competitions[0].date_end | date :'d MMM y'}}</ng-container>
      </p>
    </div>
  </div>
  </div>
  </ng-container>
</ng-container>

</div>
<ng-container *ngIf="photo_selected">
<div class="wrapper">
  <div *ngIf="photos_service.athletePhotoStore.loadingRef === false ? true : false; else loading" (click)="closePhoto()" class="close-photo"></div>
  <ng-template #loading>
    <div class="close loading-throbber"></div>
  </ng-template>
<ngb-carousel
[keyboard]="photos_service.athletePhotoStore.loadingRef === false ? true : false"
[activeId]="photo_selected" #carousel
[interval]="1000*60*60*24"
[wrap]="true"
(slide)="loadMorePhotosFromCarousel($event)"
[showNavigationArrows]="photos_service.athletePhotoStore.loadingRef === false ? true : false"
[showNavigationIndicators]="false">
  <ng-container class="element" *ngFor="let photo of data|async; let i=index">
      <ng-template [id]="photo.urls[0].median.toString()" ngbSlide>
          <div style="display: flex; flex-direction:column;" [ngStyle]="{'max-width':viewPhotoClass}" [ngClass]="{'responsive-height':(dataAthleteDetail | async)?.length >0}"  class="content-photo">
            <img [alt]="photo.alt" (load)="onLoad($event)"  *ngIf="photo.urls[0].median && carousel.activeId.toString() === photo.urls[0].median.toString()"  [src]="originalPhotoUrl(photo.urls[0].median, i)"/>
            <ng-container *ngIf="ready">
            <div [ngClass]="viewPhotoClass === '483px' ? 'vertical-photo' : 'horizontal-photo'" class="events-information">
              <ng-container>
                <div *ngIf="photo.competitions[0]" class="info-event-block">              <div style="height: 120px; width: 120px;">
                <div *ngIf="photo.competitions[0]"  [isImage]="true" class="photo-event" [size]="100" appCompetitionLink [competitionId]="photo.competitions[0].id"></div>
                </div>

                <div *ngIf="photo.competitions[0]" class="events-information-box">              <h6>
                 <a class="uppertext-no-viewport"  appCompetitionLink [competitionId]="photo.competitions[0].id">{{photo.competitions[0].name}}</a>
                </h6>
                  <div class="country">
                  <div class="country__name">
                    {{photo.competitions[0].place }}
                  </div>
                   <lib-country-flag [id]="photo.competitions[0].country"></lib-country-flag>
                  <p>
                    {{photo.competitions[0].date_start | date :'d' }}

                    <ng-container *ngIf="photo.competitions[0].date_start && photo.competitions[0].date_start !== '' && photo.competitions[0].date_end && photo.competitions[0].date_end &&  photo.competitions[0].date_end !==  photo.competitions[0].date_start  ">{{'TO' | transloco}} </ng-container>
                    <ng-container *ngIf="photo.competitions[0].date_end && photo.competitions[0].date_end != '' && photo.competitions[0].date_end !== photo.competitions[0].date_start"> {{photo.competitions[0].date_end | date :'d MMM y'}}</ng-container>
                  </p>
                </div>
                </div>
              </div>

                <div class="athletes-info" *ngIf="photo.entries && photo.entries.length > 0 && photo.competitions[0]">
                  <ng-container>
                  <div class="athlete" *ngFor="let athlete of photo.entries">
                    <lib-athlete-photo [isTeam]="false" [id]="athlete.id" ></lib-athlete-photo>
                    <lib-athlete-name [color]="'white'" [id]="athlete.id" [wnameord]="athlete.WNameOrd" [fname]="athlete.FName" [gname]="athlete.GName"></lib-athlete-name>
                  </div>
                </ng-container>
                </div>

                <div class="athletes-info-no-competition" *ngIf="photo.entries && photo.entries.length > 0 && !photo.competitions[0]">
                  <ng-container>
                    <div class="athlete" *ngFor="let athlete of photo.entries">
                      <lib-athlete-photo [isTeam]="false" [id]="athlete.id" ></lib-athlete-photo>
                      <lib-athlete-name [color]="'white'" [id]="athlete.id" [wnameord]="athlete.WNameOrd" [fname]="athlete.FName" [gname]="athlete.GName"></lib-athlete-name>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
          </div>

      </ng-template>

      </ng-container>
  </ngb-carousel>

</div>
</ng-container>
<app-load-more-button style="margin-top: 20px;" *ngIf="(photos_service.athletePhotoStore.loadingRef !== true) &&
 (photos_service.areMoreData()); else noResults" [areMoreData]="photos_service.areMoreData()" [loading]="photos_service.athletePhotoStore.loadingRef" (loadMore)="loadMore()"></app-load-more-button>
<ng-template #noResults>
  <div class="loading-throbber" *ngIf="photos_service.athletePhotoStore.loadingRef === true"></div>
  <div class="not-found-research uppercase" *ngIf="(photos_service.athletePhotoStore.loadingRef === false) && photos_service.athletePhotoStore.data.length === 0">{{'no_results' | transloco}}</div>
</ng-template>
</div>
